var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
export const Item = (_a) => {
    var { allytmln, children, index, variant = 'button', text, onClick, active, selected, onItemSelect, menuItemsRef, onOpenChange, getItemProps, ariaLabel } = _a, others = __rest(_a, ["allytmln", "children", "index", "variant", "text", "onClick", "active", "selected", "onItemSelect", "menuItemsRef", "onOpenChange", "getItemProps", "ariaLabel"]);
    const handleSelect = () => {
        onItemSelect();
        onOpenChange(false);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleKeyDown = (event) => {
        if (index === 0 && event.key === 'Tab' && event.shiftKey) {
            onOpenChange(false);
            return;
        }
        if (variant === 'button' && event.key === 'Enter') {
            event.preventDefault();
            handleSelect();
        }
    };
    const elementProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, others), { 'aria-label': ariaLabel, 'data-allytmln': allytmln, ref: (node) => {
            menuItemsRef.current[index] = node;
        } }), (selected && variant === 'button'
        ? { 'aria-current': true, 'data-selected': true }
        : {})), getItemProps({
        // If the item is a link, we will call the onClick handler but we are not "selecting" this item
        onClick: variant === 'button' ? handleSelect : onClick,
        onKeyDown: handleKeyDown,
    })), { 'data-active': active });
    return variant === 'button' ? (React.createElement("li", { role: "none" },
        React.createElement("button", Object.assign({}, elementProps, { type: "button", role: "menuitem" }), text))) : (React.createElement("li", { role: "none" },
        React.createElement("a", Object.assign({}, elementProps, { role: "menuitem" }), text)));
};
const StyledItem = styled(Item) `
  ${({ theme: { colors, space, font }, active }) => `
    display: block;
    background-color: transparent;
    width: 100%;
    text-align: left;
    min-width: 180px;
    font-size: ${font.body.md.size};
    line-height: ${font.body.md.lineHeight};
    padding: ${space.xs};
    border: none;
    outline: none;
    cursor: pointer;
    text-decoration: none;
    color: ${colors['gray-900']};

    ${active ? `background-color: ${colors['gray-200']}` : ''};
  `}
`;
export { StyledItem as DropdownMenuItem };
//# sourceMappingURL=DropdownMenuItem.js.map